<div
    class="anc-field"
    [class.anc-field--floating]="floating()"
    [class.anc-field--focused]="focused()"
>
    @if (embeddedControl(); as ctrl) {
        <input
            class="form-control"
            type="text"
            [formControl]="ctrl"
            [readonly]="readonly()"
            autocomplete="off"
            ancFieldValidate
            [ancFieldValidateSubmitted]="validateSubmitted()"
        />
    }
    <label class="anc-field__label" translate>
        {{ label() }}<sup class="super-star" *ngIf="required()">*</sup>
    </label>
    @if (
        showRequiredError() ||
        showMinlengthError() ||
        showMaxlengthError() ||
        showPatternError()
    ) {
        <div ancError>
            @if (showRequiredError()) {
                <div class="has-error" translate>{{ requiredErrorMessage() }}</div>
            } @else if (showMinlengthError()) {
                <div class="has-error" translate>{{ minlengthMessage() }}</div>
            } @else if (showMaxlengthError()) {
                <div class="has-error" translate>{{ maxlengthMessage() }}</div>
            } @else if (showPatternError()) {
                <ng-container [ngSwitch]="true">
                    <div
                        *ngSwitchCase="isEmpty(phoneValue())"
                        class="has-error"
                        translate
                    >
                        {{ patternEmptyMessage() }}
                    </div>
                    <div
                        *ngSwitchCase="hasInvalidCharacter(phoneValue())"
                        class="has-error"
                        translate
                    >
                        {{ patternInvalidCharacterMessage() }}
                    </div>
                    <div
                        *ngSwitchCase="hasDigitBeforeParentheses(phoneValue())"
                        class="has-error"
                        translate
                    >
                        {{ patternDigitBeforeParenthesesMessage() }}
                    </div>
                    <div
                        *ngSwitchCase="hasEmptyParentheses(phoneValue())"
                        class="has-error"
                        translate
                    >
                        {{ patternEmptyParenthesesMessage() }}
                    </div>
                    <div
                        *ngSwitchCase="hasMultiplePlus(phoneValue())"
                        class="has-error"
                        translate
                    >
                        {{ patternMultiplePlusMessage() }}
                    </div>
                    <div
                        *ngSwitchCase="plusAfterDigit(phoneValue())"
                        class="has-error"
                        translate
                    >
                        {{ patternPlusAfterDigitMessage() }}
                    </div>
                    <div
                        *ngSwitchCase="hasNoDigits(phoneValue())"
                        class="has-error"
                        translate
                    >
                        {{ patternNoDigitsMessage() }}
                    </div>
                    <div
                        *ngSwitchCase="exceedsMaxDigits(phoneValue())"
                        class="has-error"
                        translate
                    >
                        {{ patternExceedsMaxDigitsMessage() }}
                    </div>
                    <div *ngSwitchDefault class="has-error" translate>
                        {{ patternDefaultMessage() }}
                    </div>
                </ng-container>
            }
        </div>
    }
    <ng-content select="[ancHint]"></ng-content>
</div>
